import { render, staticRenderFns } from "./rules-edit-form.vue?vue&type=template&id=a178da00&"
import script from "./rules-edit-form.vue?vue&type=script&lang=js&"
export * from "./rules-edit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports